import { render, staticRenderFns } from "./resultados-finais.vue?vue&type=template&id=4731dd9e"
import script from "./resultados-finais.vue?vue&type=script&lang=js"
export * from "./resultados-finais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports